<template>
  <div>
    <div class="site-footer">
      <div class="container-w d-flex">
        <el-row>
          <el-col :span="16" class="footer-row">
            <el-row>
              <!-- Column 1 -->
              <el-col :span="8">
                <ul>
                  <li class="t">{{ footerData[0].sections[0].section_header.text }}</li>
                  <li>
                    <router-link :to="footerData[0].sections[0].item_one.route">
                      {{ footerData[0].sections[0].item_one.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[0].item_two.route">
                      {{ footerData[0].sections[0].item_two.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[0].item_three.route">
                      {{ footerData[0].sections[0].item_three.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[0].item_four.route">
                      {{ footerData[0].sections[0].item_four.text }}
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <!-- --- -->
              <!-- Column 2 -->
              <el-col :span="8">
                <ul>
                  <li class="t">{{ footerData[0].sections[1].section_header.text }}</li>
                  <li>
                    <router-link :to="footerData[0].sections[1].item_one.route">
                      {{ footerData[0].sections[1].item_one.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[1].item_two.route">
                      {{ footerData[0].sections[1].item_two.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[1].item_three.route">
                      {{ footerData[0].sections[1].item_three.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[1].item_four.route">
                      {{ footerData[0].sections[1].item_four.text }}
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <!-- --- -->
              <!-- Column 3 -->
              <el-col :span="8">
                <ul>
                  <li class="t">{{ footerData[0].sections[2].section_header.text }}</li>
                  <li>
                    <router-link :to="footerData[0].sections[2].item_one.route">
                      {{ footerData[0].sections[2].item_one.text }}
                    </router-link>
                  </li>
                  <li>
                    <!-- <router-link to="/login/register">
                      推广赚钱
                    </router-link> -->
                    <router-link :to="footerData[0].sections[2].item_two.route" v-if="$store.state.loginType">
                      {{ footerData[0].sections[2].item_two.text }}
                    </router-link>
                    <router-link to="/login" v-if="!$store.state.loginType">
                      {{ footerData[0].sections[2].item_two.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[2].item_three.route">
                      {{ footerData[0].sections[2].item_three.text }}
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="footerData[0].sections[2].item_four.route">
                      {{ footerData[0].sections[2].item_four.text }}
                    </router-link>
                  </li>
                </ul>
              </el-col>
              <!-- --- -->
            </el-row>
          </el-col>
          <!-- <el-col :span="3" class="qr-list">
            <div class="qr-item">
              <div id="QrCode"></div>
              <span>{{ codes[0].title }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="3" class="qr-list">
            <div class="qr-item">

            </div>
          </el-col> -->
          <!-- Column 4 -->
          <el-col :span="8" class="work-info">
            <h3>{{ footerData[0].sections[3].section_header }}</h3>
            <h2>{{ footerData[0].sections[3].phone_primary }}</h2>
            <h2>{{ footerData[0].sections[3].phone_secondary }}</h2>
            <p>{{ footerData[0].sections[3].working_hours }}<br>
              {{ footerData[0].sections[3].holidays }}</p>
          </el-col>
          <!-- --- -->
        </el-row>
      </div>
      <div class="version-text">
        <span style="margin-right: 10px;">{{ $t('myAccountPc.versionNumber') }} : {{ version }}</span><span>{{  $t('account.buildNumber') }} : {{ description }}</span>
      </div>
    </div>
    
    <div class="copyright">
      <div class="container-w footer-row">
        <a v-if="copyright.display" v-for="(copyright, index) in footerData[1].copyrightImages" :key="index"
          href="javascript:void(0);"><img :src="copyright.url" height="47px" width="127px" alt=""></a>
      </div>
      <div class="container-w" style="font-size:16px;margin-top:10px;">
        {{ footerData[1].text }} </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import { version,description } from './../../package.json';
export default {
  name: "Footer",
  data() {
    return {
      footerData: [
        {
          component_id: 11,
          component_name: "quick_links",
          label: "field.HomeConfig_quick_links",
          priority: 6,
          sections: [
            {
              section_header: {
                text: '',
                route: ''
              },
              item_one: {
                text: '',
                route: ''
              },
              item_two: {
                text: '',
                route: ''
              },
              item_three: {
                text: '',
                route: ''
              },
              item_four: {
                text: '',
                route: ''
              }
            },
            {
              section_header: {
                text: '',
                route: ''
              },
              item_one: {
                text: '',
                route: ''
              },
              item_two: {
                text: '',
                route: ''
              },
              item_three: {
                text: '',
                route: ''
              },
              item_four: {
                text: '',
                route: ''
              }
            },
            {
              section_header: {
                text: '',
                route: ''
              },
              item_one: {
                text: '',
                route: ''
              },
              item_two: {
                text: '',
                route: ''
              },
              item_three: {
                text: '',
                route: ''
              },
              item_four: {
                text: '',
                route: ''
              }
            },
            {
              section_header: '',
              working_hours: '',
              holidays: '',
              phone_primary: '',
              phone_secondary: ''
            }
          ],
          styles: {
            font_color: "#000000"
          },
          redirect_url: "",
          display: true,
          icon: "el-icon-link"
        }, {
          component_id: 10,
          component_name: "copyright",
          label: "field.HomeConfig_copyrights_label",
          priority: 8,
          styles: {
            font_color: "#000000"
          },
          text: "",
          redirect_url: "",
          display: true,
          icon: "el-icon-postcard",
          copyrightImages: [
          ],
        }
      ],
      phone: ["", ""], //电话
      codes: [
        { code: "", title: "" },
        { code: "", title: "" },
        { code: "", title: "" }
      ], //微信二维码
      qq: [""], //QQ
      copyright: "", //版权
      link: [], //友情链接
      version: version,
      description: description,
    };
  },
  mounted: function () {
    this.getComponents();
    this.getFooterData();
  },
  methods: {
    getComponents() {
      let that = this;
      that
        .$http({
          url: "/app/Components/pcComponents",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            const components = JSON.parse(res.data.data[0].components_data);
            
            //Filter out quick links
            const componentQuickLinks = components.find(component => component.component_id == 11);

            //Filter out copyrights
            const componentCopyrights = components.find(component => component.component_id == 10);

            if(componentQuickLinks && componentCopyrights){
              that.footerData = [componentQuickLinks, componentCopyrights];
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    QrCode(url) {
      new QRCode('QrCode', {
        width: 120,
        height: 120,
        text: url, // 二维码地址
      })
    },
    //获取页面底部信息
    getFooterData() {
      let that = this;
      that
        .$http({
          url: "/app/Sysconfig/web_common",
          method: "post",
          data: {

          },
          transformRequest: [(data) => JSON.stringify(data)]
        })
        .then(function (res) {
          if (res.data.status == 200) {
            var data = res.data.data;
            that.phone = data.phone;
            that.codes = data.codes;
            that.qq = data.qq;
            that.copyright = data.copyright;
            that.link = data.link;
            that.QrCode(that.codes[0].code);
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/style.css");

.footer-row ul {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
}

.footer-row ul li {
  list-style: none;
}

.footer-row ul li a {
  color: #000000;
}

.footer-row .t {
  font-size: 18px;
  font-weight: bolder;
  padding-bottom: 5px;
}

.footer-row img {
  width: 80px;
  height: 35px;
}

.version-text{
  font-size: 10px;
  margin-top: 20px;
  color: #566573  ;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: -5px;
}

.copyright[data-v-6c4d8baa] {
    padding: 0px 0;
}
</style>






// WEBPACK FOOTER //
// src/components/footer.vue